module.exports = __webpack_public_path__ + "assets/closure-library.d2e720fc.svg";